import { Injectable } from "@angular/core";
import { DocSetDetailsStoreService } from "../doc-set-details-store/doc-set-details-store.service";

@Injectable()
export class DocSetStoreFacadeService {
  constructor(public docSetDetails: DocSetDetailsStoreService) {}
}
